
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { Info } from "lucide-react";
import { ReactNode } from "react";

interface InfoBoxProps {
  title?: string;
  children: ReactNode;
  className?: string;
}

export function InfoBox({ title, children, className }: InfoBoxProps) {
  return (
    <Alert className={`bg-card border border-input mb-6 ${className}`}>
      <Info className="h-4 w-4 text-primary" />
      {title && <AlertTitle className="mb-2 mt-1">{title}</AlertTitle>}
      <AlertDescription className="text-muted-foreground">{children}</AlertDescription>
    </Alert>
  );
}
